// Browser shim for node:path. Only `dirname` is used by the SDK, and only
// when a file path is configured (never, in the client-only build).
export function dirname(p: string): string {
  const i = p.lastIndexOf("/");
  return i <= 0 ? "." : p.slice(0, i);
}
